<template>
  <b-modal
    id="editarIteracion"
    title="Editar aviso"
    size="lg"
    hide-footer
    lazy
    @show="init"
  >
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div v-if="iteracion">
            <div class="row">
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label for="periodo" class="label">Periodo</label>
                <input
                  disabled
                  class="form-control bg-white"
                  style="cursor: text"
                  type="month"
                  id="periodo"
                  name="periodo"
                  v-model="periodo"
                />
              </div>

              <div class="col-12 col-md-6 form-group form-group-sm">
                <label for="fecha_iteracion" class="label"
                  >Fecha de Aviso</label
                >
                <input
                  class="form-control"
                  type="datetime-local"
                  id="fecha_iteracion"
                  name="fecha_iteracion"
                  v-model="fechaIteracion"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-12 form-group form-group-sm">
                <SelectorMotivos v-model="motivo" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="comentarios" class="label"
                    >Comentarios Anteriores</label
                  >
                  <div
                    style="
                      background: #e4e4e4;
                      border: 1px solid #e4e4e4;
                      border-radius: 2%;
                      padding: 1px;
                    "
                    v-html="comentarios"
                  ></div>
                </div>
              </div>
              <div class="col-12 form-group form-group-sm">
                <label for="fecha_compromiso" class="label"
                  >Fecha de Compromiso</label
                >
                <input
                  class="form-control"
                  type="date"
                  id="fecha_compromiso"
                  name="fecha_compromiso"
                  v-model="fechaCompromiso"
                />
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="comentarios" class="label">Comentarios</label>
                  <textarea
                    id="comentarios"
                    v-model="comentarioNuevo"
                    class="form-control"
                    rows="6"
                    name="comentarios"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div v-else>Cargando...</div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="closeModal"
                  type="button"
                  class="btn btn-danger"
                >
                  Cancelar
                </button>

                <button type="submit" class="btn btn-primary">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { get } from "lodash-es";
import SelectorMotivos from "../Tickets/Historial/NuevoAviso/SelectorMotivos.vue";
import axios from "axios";

export default {
  name: "EditarIteracionModal",
  data: () => ({
    comentarioNuevo: "",
    fechaIteracion: "",
  }),
  components: { SelectorMotivos },
  computed: {
    ticket() {
      return this.$store.state.Suspensiones.EvitarSuspensiones.ticket;
    },
    periodo: {
      get() {
        return this.$moment().format("YYYY-MM");
      },
    },
    iteracion: {
      get() {
        return this.$store.state.Suspensiones.EvitarSuspensiones.iteracion;
      },
      set(val) {
        return this.$store.commit(
          "Suspensiones/EvitarSuspensiones/setIteracionAEditar",
          val,
        );
      },
    },
    fechaCompromiso: {
      get() {
        if (this.iteracion && this.iteracion.fecha_compromiso) {
          const fechaHora = this.iteracion.fecha_compromiso;
          return this.$moment(fechaHora).format("YYYY-MM-DD");
        }
        return null;
      },
      set(val) {
        let nuevaFecha = null;
        if (val) nuevaFecha = this.$moment(val).format("YYYY-MM-DD");
        this.iteracion = { ...this.iteracion, fecha_compromiso: nuevaFecha };
      },
    },

    motivo: {
      get() {
        if (this.iteracion) {
          if (this.iteracion.motivo) {
            return this.iteracion.motivo;
          } else {
            return this.iteracion.id_motivo;
          }
        }
        return null;
      },
      set(val) {
        this.iteracion = {
          ...this.iteracion,
          motivo: val,
        };
      },
    },
    comentarios() {
      if (this.iteracion && this.iteracion.comentarios) {
        const coment = get(this.iteracion, "comentarios", "");
        return coment;
      }
      return "";
    },
  },
  methods: {
    init() {
      this.iteracion =
        this.$store.getters[
          "Suspensiones/EvitarSuspensiones/getIteracionAEditar"
        ];
      this.comentarioNuevo = "";
      this.fechaIteracion = this.$moment().format("YYYY-MM-DD HH:mm");
    },
    async submit() {
      if (!this.comentarioNuevo) {
        this.$msgBoxOk("Por favor, agrega un comentario");
        return;
      }
      if (this.ticket && this.ticket.resuelto_fecha !== null) {
        this.$msgBoxOk(
          "El ticket ya está resuelto. No se pueden realizar más ediciones.",
        );
        return;
      }

      const resp = await axios.post("/execute", {
        method: "CLI.EditarIteracionDeTicket",
        parameters: [
          {
            name: "id_iteracion",
            value: this.iteracion.id_iteracion,
          },
          {
            name: "id_motivo",
            value: this.motivo ? this.iteracion.motivo.id_motivo : null,
          },
          {
            name: "fecha_compromiso",
            value: this.fechaCompromiso,
          },
          {
            name: "fecha_iteracion",
            value: this.$moment(this.fechaIteracion).format("YYYY-MM-DD HH:mm"),
          },
          {
            name: "comentarios",
            value: this.comentarioNuevo,
          },
        ],
      });
      if (get(resp.data, "ok", false)) {
        this.$msgBoxOk("Éxito!");
        this.$store.commit(
          "Suspensiones/EvitarSuspensiones/setIteracionAEditar",
        );
        this.$emit("update");
        this.closeModal();
      } else {
        this.$msgBoxOk(resp.message);
      }
    },
    closeModal() {
      this.$bvModal.hide("editarIteracion");
    },
  },
};
</script>

<style scoped></style>
